import { render, staticRenderFns } from "./JR2.vue?vue&type=template&id=76dc7b22"
import script from "./JR2.vue?vue&type=script&lang=js"
export * from "./JR2.vue?vue&type=script&lang=js"
import style0 from "./JR2.vue?vue&type=style&index=0&id=76dc7b22&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports